// Number of days after which personnel's compliance is considered out of compliance
export const OUT_OF_COMPLIANCE_DAYS_THRESHOLD = 30;